import { createStyles, InputBase, Theme, withStyles } from '@material-ui/core';

const StyledInput = withStyles(({ palette }: Theme) => createStyles({
  input: {
    borderRadius: 3,
    position: 'relative',
    border: `1px solid ${palette.studio.borderColor}`,
    fontSize: 16,
    padding: '9px 26px 9px 12px',
    '&:focus': {
      borderRadius: 3,
      borderColor: palette.studio.borderColor,
    },
    '&:disabled': {
      color: '#515B6A !important',
    },
  },
}))(InputBase);

export default StyledInput;
